import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { selectBudgets } from '../selectors';
import { useBudgetSetRolloverModal } from './useBudgetSetRolloverModal';
export const useBudgetRollover = (initialValue, toggleSwitchState, flow) => {
    const budgets = useAppSelector(selectBudgets);
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'rollingBudgets',
    });
    const saveHandlerRef = useRef(null);
    const setSaveHandler = useCallback((handler) => {
        saveHandlerRef.current = handler;
    }, []);
    const runSaveHandler = useCallback((isRollover) => {
        if (saveHandlerRef.current) {
            saveHandlerRef.current(isRollover);
            saveHandlerRef.current = null;
        }
    }, []);
    const [isRolloverLocal, setRolloverLocal] = useState(() => {
        if (!isUnlockedForSpace) {
            return false;
        }
        if (initialValue !== undefined) {
            return initialValue;
        }
        return budgets.some((budget) => !!budget.shouldRollover);
    });
    const setOnUpgrade = useRef(undefined);
    useEffect(() => {
        if (setOnUpgrade.current && isUnlockedForSpace) {
            setRolloverLocal(true);
            setOnUpgrade.current = undefined;
        }
    }, [isUnlockedForSpace]);
    const onSetRollover = useCallback((value) => {
        setRolloverLocal(value);
    }, []);
    const showSetModal = useBudgetSetRolloverModal(onSetRollover, runSaveHandler, toggleSwitchState, flow);
    return {
        isRollover: isRolloverLocal,
        setRollover: showSetModal,
        setRolloverLocal,
        shouldUpgrade: !isUnlockedForSpace,
        setSaveHandler,
    };
};
